// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Preloader_wrapper__2OW2G","fixed":"Preloader_fixed__2sVYr","loader":"Preloader_loader__2K_K0","rotate":"Preloader_rotate__2xDFR"};